<i18n>
{
  "ru": {
    "bestsellers": "Хиты продаж",
    "newArrivals": "Новые поступления",
    "promotions": "Акции"
  },
  "uk": {
    "bestsellers": "Хіти продажів",
    "newArrivals": "Нові надходження",
    "promotions": "Акції"
  }
}
</i18n>

<template>
  <div class="col-md-12">
    <b-tabs class="as-nav-tabs">
      <b-tab :title="$t('bestsellers')" active>
        <div class="row" v-if="$store.state.GlobalData.products">
          <div
            class="col-xl-3 col-md-4"
            v-for="(item, index) in $store.state.GlobalData.products"
            :key="index"
          >
            <Item v-bind:el="item" />
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('newArrivals')">
        <div class="row"></div>
      </b-tab>
      <b-tab :title="$t('promotions')">
        <div class="row"></div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
//import Axios from "axios";

import Item from "@/components/Item.vue";

export default {
  components: {
    Item
  }
};
</script>
